export default __webpack_public_path__ + "static/media/product6.ad53b959.jpg";